import { MdOutlineSave } from 'react-icons/md';
import { Button, Text } from 'components';
import { FontSize } from 'commons';

interface Props {
  isSubmitting: boolean;
}

export function DiscountConfirm({ isSubmitting }: Props) {
  return (
    <div className="static flex w-full justify-center">
      <div
        className="fixed bottom-6 mx-2 flex items-center gap-4 rounded-lg bg-neutral-100 p-2
          shadow-lg"
      >
        <Text size={FontSize.font12}>Você realizou alterações</Text>

        <Button type="submit" isLoading={isSubmitting}>
          <MdOutlineSave size={24} /> Salvar
        </Button>
      </div>
    </div>
  );
}
